import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-device-not-authorized',
    templateUrl: './device-not-authorized.component.html',
    styleUrls: ['./device-not-authorized.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeviceNotAuthorizedComponent {}
